
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tyres/pickup/gmc-sierra",
      function () {
        return require("private-next-pages/tyres/pickup/gmc-sierra.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tyres/pickup/gmc-sierra"])
      });
    }
  